<template>
  <div class="test-details">
    <HeadedContainer>
      <template v-slot:header>
        {{$ml.get(`TEST DETAILS`)}}
      </template>
      <div class="form">
        <div class="item">
          <app-text-input
            :label="$ml.get('Name')"
            v-model="form.name"
          />
        </div>
        <div class="item">
          <app-sel
            key-name="id"
            label-name="name"
            v-model="form.farmId"
            :items="$store.getters['farms/farms']"
            :label="$ml.get(`Farm`)"
          >
            <template v-slot="{ items }">
              <app-sel-opt
                v-for="item in items"
                :value="item"
              >
                {{ item.name }}
              </app-sel-opt>
            </template>
          </app-sel>
        </div>
        <div class="item">
          <app-sel
            key-name="id"
            label-name="name"
            :label="$ml.get(`Field`)"
            :items="fields"
            v-model="form.fieldId"
            :disabled="!form.farmId"
          >
            <template v-slot="{ items }">
              <app-sel-opt
                v-for="field in items"
                :value="field"
                :key="field.id"
              >
                {{ field.name }}
              </app-sel-opt>
            </template>
          </app-sel>
        </div>
        <div class="item">
          <date-selector :not-after="true" v-model="form.date" :label="$ml.get(`Sampling Date`)"/>
        </div>
      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {

    }
  },
  components: {
    HeadedContainer,
  },
  computed: {
    ...mapGetters({
      form: 'tests/tissue/form'
    }),
    fields() {
      const farm = this.$store.getters['farms/getFarmById'](this.form.farmId);
      if(farm) {
        return farm.fields;
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.form {
  width: 100%;
  padding-bottom: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  .item {
    // width: 33.3%;
    width: 50%;
    margin-top: 30px;
    padding: 0 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      width: 100%;
    }
  }
}

</style>
